import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { InscriptionsRedux } from '../Redux/InscriptionsRedux'

const inscriptionsCrudObservable = createCRUDObservable({
  mainRedux: InscriptionsRedux,
  reduxPath: 'inscriptions',
  dataHandlers: {
    get: response => response.data,
  },
})

export const inscriptionsObservers = Object.assign({}, inscriptionsCrudObservable.observers, {})

export const inscriptionsEpic = combineEpics(
  inscriptionsCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/InscriptionsObservable.js